<template>
  <div>
    <!-- 退换货办理 -->
    <div class="rj-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>合同列表</el-breadcrumb-item>
        <el-breadcrumb-item>合同基本信息</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <baseInfoCheck :info="info" />
    <see-file />
    <rj-tabs v-model="tabsActive">
      <!-- <rj-tab-pane name="1" label="销退明细">
        <el-table :data="tableData1" border style="width: 100%">
          <el-table-column type="index" width="60" label="序号" align="left" />
          <el-table-column prop="" label="订单号" align="left" />
          <el-table-column prop="rcreatedTime" label="销退日期" align="left" />
          <el-table-column prop="rnewContractNum" label="销退单号" align="left" />
          <el-table-column prop="rMaterialNum" label="物品代码" align="left" />
          <el-table-column prop="rproductSalesName" label="产品名称" align="left" />
          <el-table-column prop="rproductNum" label="销退数量" align="left" />
        </el-table>
      </rj-tab-pane> -->
      <rj-tab-pane name="1" label="退货明细">
        <!-- <contractual-product :str-contract-code="this.$route.query.number" :init-info="info" /> -->
        <el-table :data="tableData1" border style="width: 100%" show-summary
                  :summary-method="getSummaries"
        >
          <el-table-column type="index" width="70" label="序号" align="left" fixed="left" />
          <el-table-column
            prop="erpLineNum"
            label="ERP行号"
            align="left"
            fixed="left"
          />

          <el-table-column
            prop="rproductCode"
            label="销售产品代码"
            width="110"
            align="left"
            fixed="left"
          />
          <el-table-column
            prop="rproductSalesName"
            label="商品名称"
            align="left"
            width="230"
          />
          <el-table-column
            prop="rproductName"
            label="产品型号"
            align="left"
            width="180"
          />
          <el-table-column
            prop="rmaterialNum"
            label="物料编码"
            align="left"
            width="180"
          />
          <el-table-column
            prop="rproductUnit"
            label="单位"
            align="left"
            width="80"
          />
          <el-table-column
            prop="rproductNum"
            label="数量"
            align="left"
            width="100"
          >
            <template slot-scope="{ row }">
              -{{ row.rproductNum }}
            </template>
          </el-table-column>
          <el-table-column
            prop="rproductPrice"
            label="单价"
            align="right"
            width="130"
            header-align="left"
          />
          <el-table-column
            prop="rproductPriceAdd"
            label="订单金额"
            align="right"
            width="130"
            header-align="left"
          />
          <el-table-column
            prop="rproductActualPriceAdd"
            label="实际结算金额"
            align="right"
            width="130"
            header-align="left"
          />
          <el-table-column
            prop="rbeforeSplitPrice"
            label="拆分前单价"
            align="right"
            width="130"
            header-align="left"
          />
          <el-table-column
            prop="rstorageName"
            label="库位"
            align="left"
            width="130"
          />
          <el-table-column
            prop="rfictitiousReturn"
            label="真实/虚拟退货"
            align="left"
            width="180"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.rfictitiousReturn">真实退</span>
              <span v-if="!scope.row.rfictitiousReturn">虚拟退</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="taxRate"
            label="税率"
            align="left"
            width="120"
          />
        </el-table>
      </rj-tab-pane>
      <rj-tab-pane name="2" label="分配明细">
        <el-table :data="tableData2" border show-summary :summary-method="getDistributionSummaries" style="width: 100%">
          <el-table-column type="index" width="60" label="序号" align="left" />
          <el-table-column prop="rteleNum" label="电汇底单编号" align="left" />
          <el-table-column v-if="this.$route.query.rcontractType === '退货合同'" prop="rorderMoney" label="订单金额" align="right" width="150" header-align="left" />
          <el-table-column v-if="this.$route.query.rcontractType === '换货合同'" prop="ractualSettlementAmount" label="订单金额" align="right" width="150" header-align="left" />
          <el-table-column v-if="this.$route.query.rcontractType === '退货合同'" prop="rrefundAmount" label="实际退款金额" align="right" width="150" header-align="left" />
          <el-table-column prop="rassignAmount" label="已分配金额" align="right" width="150" header-align="left" />
          <el-table-column prop="rassignAmountNum" label="已分配金额比例" align="right" width="150" header-align="left">
            <template slot-scope="{ row }">
              {{ row.distributionProportion >= 100 ? 100 : row.distributionProportion }}%
            </template>
          </el-table-column>
          <el-table-column prop="rcreatedBy" label="分配人" align="left" />
          <el-table-column prop="rcreatedTime" label="分配日期" align="left" />
          <!-- 同步ERP状态 -->
          <el-table-column label="同步ERP状态" align="left" width="120">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.rsyncSuccessFlag === false"
                type="text"
                @click="showErrorDetail(scope.row)"
              >
                失败
              </el-button>
              <span v-else>
                {{ scope.row.rsyncSuccessFlag === true ? '成功' : '待抛转' }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </rj-tab-pane>
      <rj-tab-pane name="3" label="退票明细" />
      <!-- <rj-tab-pane name="4" label="退货明细">
        <el-table :data="tableData3" border style="width: 100%">
          <el-table-column prop="stateDateTime" label="序号" align="left" />
          <el-table-column prop="stateDateTime" label="订单号" align="left" width="150" />
          <el-table-column prop="stateDateTime" label="销退日期" align="left" width="150" />
          <el-table-column prop="stateDateTime" label="销退单号" align="left" width="150" />
          <el-table-column prop="stateDateTime" label="物品代码" align="left" width="150" />
          <el-table-column prop="stateDateTime" label="产品名称" align="left" width="150" />
          <el-table-column prop="stateDateTime" label="销退数量" align="left" width="150" />
        </el-table>
      </rj-tab-pane> -->
    </rj-tabs>
    <!-- 抛单异常详情 -->
    <el-dialog
      title="分配记录同步ERP状态查看"
      :visible.sync="errorDialogVisible"
      width="500px"
    >
      <div class="error-detail">
        <div class="error-item">
          <div class="error-value error-reason">{{ currentErrorInfo.rsyncFailReason }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="errorDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import baseInfoCheck from './baseInfoCheck';
import SeeFile from './invoice-file/SeeFile.vue';
import tabs from '@/components/Tabs/tabs';
import tabPane from '@/components/Tabs/tabPane';
// import history from './history.vue';
// import productCheck from './productCheck.vue';
import { getApproveData, getAssignLogByContractId } from '@/API';
import { MathAdd, MathMulti } from '@/libs/util';

export default {
  components: {
    baseInfoCheck,
    SeeFile,
    'rj-tab-pane': tabPane,
    'rj-tabs': tabs
    // productCheck
  },

  data () {
    return {
      tabsActive: '1',
      contractNum: '123',
      info: {},
      tableData1: [],
      tableData2: [],
      tableData3: [],
      tableData4: [],
      errorDialogVisible: false,
      currentErrorInfo: {}
    };
  },
  props: {

  },
  mounted () {
    this.initData();
  },
  methods: {
    submit () {
      let history = this.$refs.history.rejectedList;
      console.log(history);
    },

    // 分配明细 合计
    getDistributionSummaries (param) {
      const { columns, data } = param;
      const sums = [];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '已分配金额') {
          sums[index] = data.reduce((pre, cur) => MathAdd(pre, cur.rassignAmount), 0);
          return;
        }
        if (column.label === '已分配金额比例') {
          sums[index] = data.reduce((pre, cur) => {
            let num = cur.distributionProportion >= 100 ? 100 : cur.distributionProportion;
            return MathAdd(pre, num);
          }, 0) + '%';
        }
      });
      return sums;
    },

    getSummaries (param) {
      // let allowsum = ['数量', '订单金额', '实际结算金额'];
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '数量') {
          sums[index] = this.rproductNumAmount(param.data);
          return;
        }
        if (column.label === '订单金额') {
          sums[index] = this.rproductPriceAddAmount(param.data);
          return;
        }
        if (column.label === '实际结算金额') {
          sums[index] = this.rproductActualPriceAddAmount(param.data);
          return;
        }
        if (column.label === '拆分前单价') {
          sums[index] = this.rbeforeSplitPriceAmount(param.data);
        }
      });
      return sums;
    },
    rproductNumAmount (tag) {
      let cont = 0;
      tag.forEach((item) => {
        cont = MathAdd(cont, item.rproductNum);
      });
      return `-${cont}`;
    },
    rproductPriceAddAmount (tag) {
      let cont = 0;
      tag.forEach((item) => {
        cont = MathAdd(cont, item.rproductPriceAdd);
      });
      return `-${cont.toFixed(2)}`;
    },
    rbeforeSplitPriceAmount (tag) {
      let cont = 0;
      tag.forEach((item) => {
        cont = MathAdd(cont, MathMulti(item.rbeforeSplitPrice, Number(item.rproductNum)));
      });
      return `-${cont.toFixed(2)}`;
    },
    rproductActualPriceAddAmount (tag) {
      let cont = 0;
      tag.forEach((item) => {
        cont = MathAdd(cont, item.rproductActualPriceAdd);
      });
      // this.allCont = cont;
      return `-${cont.toFixed(2)}`;
    },
    async initData () {
      // let parmas = {
      //   contractId: this.$route.query.contractId
      // };
      var res = await getApproveData(this.$route.query.rcontractId, this.$route.query.rcontractType, this.$route.query.action);
      const json = res.data;
      if (json.status === '200') {
        this.$nextTick(() => {
          this.info = json.data.baseInfoModelVO;
          this.tableData1 = json.data.addressMOdelVOS[0].addressList[0].contractProductList;
        });
      }
      // getApproveData(this.$route.query.rcontractId, this.$route.query.rcontractType).then((res) => {
      //   let json = res.data;
      //   if (json.status === '200') {
      //     this.$nextTick(() => {
      //       this.info = json.data.baseInfoModelVO;
      //       this.tableData1 = json.data.addressMOdelVOS[0].addressList[0].contractProductList;
      //     });
      //   }
      // }).catch(() => {

      // });
      var res2 = await getAssignLogByContractId(this.$route.query.rcontractId);
      const json2 = res2.data;
      if (json2.status === '200') {
        this.$nextTick(() => {
          this.tableData2 = json2.data || [];
          this.tableData2.forEach((item) => {
            item.rrefundAmount = this.info.rrefundAmount;
            item.ractualSettlementAmount = this.info.ractualSettlementAmount;
            item.rorderMoney = this.info.rorderMoney;
          });
          // this.tableData2.forEach((item) => {
          //   item.rassignAmountNum = (item.rassignAmount / item.ractualSettlementAmount * 100) + '%';
          // });
        });
      }
      // getAssignLogByContractId(this.$route.query.rcontractId).then((res) => {
      //   let json = res.data;
      //   if (json.status === '200') {
      //     this.$nextTick(() => {
      //       this.tableData2 = json.data;
      //       this.tableData2.forEach((item) => {
      //         item.rassignAmountNum = item.rassignAmount / item.rrefundAmount;
      //       });
      //       // this.approveLogList = json.data.approveLogList;
      //       // this.productData = json.data.addressMOdelVOS;
      //     });
      //   }
      // }).catch(() => {

      // });
    },
    // 显示错误详情
    showErrorDetail (row) {
      this.currentErrorInfo = row;
      this.errorDialogVisible = true;
    }
  }

};
</script>

<style>
.error-item {
  margin-bottom: 16px;
  line-height: 1.6;
}
.error-label {
  font-weight: 500;
  color: #606266;
  min-width: 80px;
  display: inline-block;
}
.error-value {
  color: #303133;
  word-break: break-all;
}
.error-reason {
  white-space: pre-wrap;
}
</style>
